/** @format */

export const normalizeIsoCode = (iso: string) => {
    return iso.replace('_', '-');
};
